import React from "react";
import { makeStyles } from "@material-ui/core";
// import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import VisibilitySensor from "react-visibility-sensor";

import SocialLinks from "./helperComponents/SocialLinks";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "fit-content",
    padding: "2em",
    transform: "translate(-50%,-50%)",
  },
  greetings: {
    fontWeight: "500",
    fontSize: "2rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  name: {
    fontSize: "4rem",
    fontWeight: "900",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem",
    },
  },
  description: {
    display: "flex",
    margin: "auto",
    alignItems: "center",
    justifyContent: "center",
  },
  img: {
    width: "200px",
    height: "200px",
    margin: "auto",
    backgroundImage: "url(assets/img/profile1.png)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "200px",
    borderRadius: "50%",
    "&:hover": {
      boxShadow: "0px 0px 25px 10px #ff8f01",
    },
  },
  tagline: {
    padding: "1em 0",
    fontSize: "1.2rem",
    fontWeight: "600",
    paddingRight: ".3rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  taglineSM: {
    padding: "1em 0",
    fontSize: "0.8rem",
    fontWeight: "600",
    paddingRight: ".3rem",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // fontSize: ".7rem",
  taglineText: {
    margin: "0 2em",
  },
  mouse: {
    width: "3rem",
    animationDuration: "1s",
    animationDelay: "1s",
    animationName: "bounceInUp",
  },
}));

const HomeContainer = ({ refProp, scrollTo, refProps, setRefInView }) => {
  const classes = useStyles();

  return (
    <VisibilitySensor
      partialVisibility
      // minTopValue={100}
      onChange={(isVisible) => isVisible && setRefInView("home")}
    >
      <div className={classes.root} ref={refProp}>
        <div>
          <Typography className={classes.greetings}>
            {"Hello, this is"}
          </Typography>
          <Typography className={classes.name}>{"Singarajan G"}</Typography>
        </div>

        <div className={classes.description}>
          <Typography
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              paddingRight: ".3rem",
            }}
          >
            {"LIC Agent & Consultant"}
          </Typography>
        </div>

        <div className={classes.description}>
          <Typography
            style={{
              fontSize: "1.2rem",
              fontWeight: "500",
              paddingRight: ".3rem",
            }}
          >
            {"(Since 1988)"}
          </Typography>
        </div>

        <div className={classes.description} style={{ paddingBottom: "1rem" }}>
          <Typography
            style={{
              fontSize: "1.2rem",
              fontWeight: "600",
              paddingRight: ".3rem",
            }}
          >
            {"Member of Chairman's Club"}
          </Typography>
        </div>

        {/* <Avatar
          alt="Singarajan G"
          src="assets/img/profile.png"
          component="div"
          className={classes.img}
        /> */}

          <div className={classes.img}></div>

        <div className={classes.tagline}>
          <span className={classes.taglineText}>{"Buy your policy today"}</span>
          <span>|</span>
          <span className={classes.taglineText}>
            {"Fulfill all your future financial needs"}
          </span>
          <span>|</span>
          <span className={classes.taglineText}>{"Ensure Peace of Mind"}</span>
        </div>

        <div className={classes.taglineSM}>
          <span>
            {
              "Buy your policy today | Fulfill all your future financial needs | Ensure Peace of Mind"
            }
          </span>
        </div>

        <SocialLinks />
      </div>
    </VisibilitySensor>
  );
};

export default HomeContainer;
